import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
/**
 * An extension of titan text. Titan text does not decrease stroke on scale.
 * This does.
 */
export class TitanTextResize extends TitanText {
    static createField(...args) {
        let _parent, _name, _properties, _portraitProperties;
        if (typeof args[1] === "string") {
            [_parent, _name, _properties, _portraitProperties] = args;
        }
        else {
            [_parent, _properties, _portraitProperties] = args;
            _name = "TextField";
        }
        let field;
        if (_properties) {
            field = new TitanTextResize(_properties, _portraitProperties);
            if (field && _parent) {
                _parent.addChild(field);
            }
        }
        return field;
    }
    resizeFont() {
        const fontSize = this.uiText.style.fontSize;
        super.resizeFont();
        const newSize = this.uiText.style.fontSize;
        this.uiText.style.strokeThickness = this.uiText.style.strokeThickness * newSize / fontSize; //adjust stroke with size
    }
}
//# sourceMappingURL=TitanTextResizer.js.map